/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Read_Along_Ai_DescriptionInputs */

const en_read_along_ai_description = /** @type {(inputs: Read_Along_Ai_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overview`)
};

const es_read_along_ai_description = /** @type {(inputs: Read_Along_Ai_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visión general`)
};

/**
* | output |
* | --- |
* | "Overview" |
*
* @param {Read_Along_Ai_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_ai_description = /** @type {((inputs?: Read_Along_Ai_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_Ai_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_ai_description(inputs)
	return en_read_along_ai_description(inputs)
});